import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BillingAccountsRoutingModule } from './billing-accounts-routing.module';
import { BillingAccountsComponent } from './billing-accounts.component';


@NgModule({
  declarations: [
    BillingAccountsComponent
  ],
  imports: [
    CommonModule,
    BillingAccountsRoutingModule
  ]
})
export class BillingAccountsModule { }
